<mat-dialog-content>
  <lemon-dialog-header> Jatkuvan tositteen summan muokkaus </lemon-dialog-header>

  <div class="tosite-tiedot">
    <form novalidate style="margin: 0">
      <mat-form-field>
        <mat-label>Summa</mat-label>
        <input decimalNumberField matInput [numberOfDecimals]="2" class="alignLeft" [formField]="lomake.summa" />
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 0; padding-right: 0; justify-content: space-around; justify-content: space-evenly">
  <app-secondary-button [focusRegionStart]="true" mat-dialog-close actionId="Peruuta (tosite, muokkaa yliajosummaa dialog)">Peruuta</app-secondary-button>
  <app-primary-button (click)="tallenna()" actionId="Tallenna tositteen muokkaus (yliajosumma)" [actionContext]="$any(lomake().value())">Tallenna</app-primary-button>
</mat-dialog-actions>
